<template>
    <input type="email" v-model="content" />
</template>

<script>
    export default {
        props: ['value'],
        data() {
            return {
                content: this.value
            };
        },
        mounted() {
            
            var id = uniqid();
            $(this.$el).attr("id", id);
            var parent = $(this.$el).parent();                      
            
            parent.prev().attr("for", id);
            parent.next().attr("id", id+"-message");
            
        },
        watch: {
            
            content(val){
                this.$emit('input', val);
            },
            value(val){
                this.content = val;
            }            
            
        },
        destroyed() {
            
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/elements/email.vue